import styled from 'styled-components';

export const CTAWrapper = styled.div`
  height: 550px;
  position: relative;
  font-family: 'acumin-pro', sans-serif;

  @media (max-width: 970px) {
    height: 320px;
    margin: 0px 10px;
  }
`;

export const CTABackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('/public-assets/images/facility-tour/cta-background.png')
    no-repeat center center;
  background-size: 100% auto;
  transition: all 220ms ease-in-out;
  z-index: 0;

  ${CTAWrapper}:hover & {
    background-size: 105% auto;
  }

  @media (max-width: 425px) {
    background-size: auto 100%;

    ${CTAWrapper}:hover & {
      background-size: auto 105%;
    }
  }
`;

export const CTABorder = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border: 0px solid rgba(255, 255, 255, 0);
  transition: all 220ms ease-in-out;
  z-index: 1;

  ${CTAWrapper}:hover & {
    top: 25px;
    left: 25px;
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    border: 1px solid rgba(255, 255, 255, 1);
  }
`;

export const CTAContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 2;
`;

export const CTAContentInner = styled.div`
  max-width: 350px;

  @media (max-width: 970px) {
    max-width: auto;
    width: 100%;
    padding: 0px 25px;
  }
`;

export const CTAHeader = styled.h2`
  &.cta-header {
    color: #ffffff;
    font-size: 2.3rem;
    font-weight: 900;
    margin-bottom: 45px;

    @media (max-width: 970px) {
      font-size: 1.7rem;
      max-width: 250px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const CTAButton = styled.a`
  &.cta-button {
    font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
    border: none;
    background: #ffffff;
    color: #0175c9;
    padding: 15px 50px;
    border-radius: 2px;
    cursor: pointer;
    text-decoration: none;
    font-size: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
  }
`;
